/* eslint-disable */

window.onload = function () {
  var ripples = document.querySelectorAll(".btn");

  for (var i = 0; i < ripples.length; i++) {
    ripples[i].addEventListener("click", function (e) {
      var targetEl = e.currentTarget;

      var rippleDiv = document.createElement("span");
      rippleDiv.classList.add("ripple");

      var maxDim = Math.max(targetEl.offsetWidth, targetEl.offsetHeight);
      rippleDiv.style.width = rippleDiv.style.height = maxDim + "px";

      // Set position
      rippleDiv.style.left = e.offsetX - maxDim / 2 + "px";
      rippleDiv.style.top = e.offsetY - maxDim / 2 + "px";

      targetEl.appendChild(rippleDiv);

      // Remove ripple after animation
      setTimeout(function () {
        if (rippleDiv.parentElement) {
          rippleDiv.parentElement.removeChild(rippleDiv);
        }
      }, 600);
    });
  }
};
